var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('table-generic',{attrs:{"module":_vm.path,"title":"Proyectos","headers":_vm.headers,"form-fields":_vm.form}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }